import React, { useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import SkeletonLoader from 'src/components/common/skeletonLoading';
import { RetentionSearchContext } from '../search';
import { getSuggestedCalc } from 'src/redux/shopping_cart/thunks';
import { selectDataSuggested } from 'src/redux/shopping_cart/shopping_cart.selectors';
import { Wrapper } from '../calculo-sugeridos/styles';
import UserInfoSummary from './UserInfoSummary';

const EMPTY_COPY = 'Busca un cliente por correo electrónico para ver su información.';
const NOT_FOUND_COPY = 'No se encontró información para el cliente buscado.';

/**
 * Tab "Información del usuario".
 *
 * Carga perezosa: al abrir el tab o al cambiar el usuario buscado (submittedQuery
 * del buscador a nivel de página) dispara `getSuggestedCalc` (suggested_calculator).
 * Renderiza el desplegable reutilizable `UserInfoSummary`.
 */
const UserInformation = () => {
    const dispatch = useAppDispatch();
    const { submittedQuery } = useContext(RetentionSearchContext);
    const { loading, errorMessage, suggested } = useAppSelector(selectDataSuggested);

    useEffect(() => {
        if (!submittedQuery) return;
        dispatch(getSuggestedCalc({ country: 'MX', email: submittedQuery, type_user: 2 }));
    }, [submittedQuery, dispatch]);

    if (!submittedQuery) {
        return <Wrapper>{EMPTY_COPY}</Wrapper>;
    }

    if (loading) {
        return (
            <Wrapper>
                <SkeletonLoader width="254px" height="20px" count={3} />
                <SkeletonLoader width="180px" height="20px" count={2} />
                <SkeletonLoader width="200px" height="20px" count={3} />
            </Wrapper>
        );
    }

    if (errorMessage || suggested.users.email === '') {
        return <Wrapper>{errorMessage || NOT_FOUND_COPY}</Wrapper>;
    }

    return <UserInfoSummary />;
};

export default UserInformation;
